import { render, staticRenderFns } from "./WeBalloon.vue?vue&type=template&id=2fff179a&"
import script from "./WeBalloon.vue?vue&type=script&lang=js&"
export * from "./WeBalloon.vue?vue&type=script&lang=js&"
import style0 from "./WeBalloon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VList,VMenu,VSubheader})
